'use client'

const features = [
    {
        status: 'Device Control',
        description: 'Turn on/off lights, adjust thermostat, control plugs, and lock/unlock doors — all from one place.',
        icon: 'pi pi-cog',
    },
    {
        status: 'Automation',
        description: 'Set schedules based on time, sunrise/sunset, or location triggers.',
        icon: 'pi pi-calendar-plus',
    },
    {
        status: 'Voice Control',
        description: 'Works seamlessly with Google Assistant, Siri (Apple HomeKit), Alexa, and more.',
        icon: 'pi pi-microphone',
    },
    {
        status: 'Family Sharing',
        description: 'Invite family members to share access and control of your devices.',
        icon: 'pi pi-users',
    },
    {
        status: 'Remote Access',
        description: 'Control all your devices from anywhere in the world with an internet connection.',
        icon: 'pi pi-globe',
    },
    {
        status: 'Group Management',
        description: 'Organize devices into rooms or custom categories for effortless control.',
        icon: 'pi pi-clone',
    },
    {
        status: 'Energy Monitoring',
        description: 'Track real-time and historical power usage of all connected devices.',
        icon: 'pi pi-chart-line',
    },
    {
        status: 'Smart Notifications',
        description: 'Receive instant alerts for motion, door sensors, or unusual device activity.',
        icon: 'pi pi-bell',
    },
    {
        status: 'Customizable Settings',
        description: 'Fine-tune brightness, color temperature, and rename devices to your preference.',
        icon: 'pi pi-sliders-h',
    },
    {
        status: 'Weather Updates',
        description: 'Get live local weather information directly inside the app.',
        icon: 'pi pi-sun',
    },
];

export const AppFeatures = () => {
    return (
        <section style={{ background: 'linear-gradient(160deg, #0a1f44 0%, #0c3264 60%, #0e4a5c 100%)', color: '#fff' }}>
            <div className="container" style={{ padding: '5rem 1.5rem' }}>

                {/* Header */}
                <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
                    <span style={{
                        display: 'inline-block',
                        background: 'rgba(0,210,190,0.12)',
                        color: '#00d2be',
                        borderRadius: '999px',
                        padding: '0.3rem 1.1rem',
                        fontSize: '0.82rem',
                        fontWeight: 600,
                        letterSpacing: '0.08em',
                        textTransform: 'uppercase',
                        marginBottom: '1rem',
                    }}>
                        Smart Life App
                    </span>
                    <h2 style={{ fontSize: 'clamp(1.6rem, 3vw, 2.4rem)', fontWeight: 700, margin: '0 0 0.75rem', lineHeight: 1.2, color: '#fff' }}>
                        Simplify. Automate. Control.
                    </h2>
                    <p style={{ color: 'rgba(255,255,255,0.6)', maxWidth: 520, margin: '0 auto', fontSize: '1rem', lineHeight: 1.6 }}>
                        One app to manage every Ennix device in your home — intuitively and intelligently.
                    </p>
                </div>

                {/* Feature grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
                    gap: '1.25rem',
                    marginBottom: '4rem',
                }}>
                    {features.map((f) => (
                        <FeatureCard key={f.status} icon={f.icon} title={f.status} description={f.description} />
                    ))}
                </div>

            </div>
        </section>
    );
};

function FeatureCard({ icon, title, description }) {
    return (
        <div style={{
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '1rem',
            padding: '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            transition: 'background 0.2s, border-color 0.2s',
        }}
        onMouseEnter={e => {
            e.currentTarget.style.background = 'rgba(0,210,190,0.08)';
            e.currentTarget.style.borderColor = 'rgba(0,210,190,0.35)';
        }}
        onMouseLeave={e => {
            e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
        }}
        >
            <div style={{
                width: 44, height: 44,
                borderRadius: '50%',
                background: 'rgba(0,210,190,0.15)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
            }}>
                <i className={icon} style={{ fontSize: '1.15rem', color: '#00d2be' }} />
            </div>
            <div style={{ fontWeight: 600, fontSize: '0.97rem', color: '#fff' }}>{title}</div>
            <div style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.6)', lineHeight: 1.55 }}>{description}</div>
        </div>
    );
}